import { TextField, MenuItem } from "@mui/material";
import { CustomTextField } from "assets/styles/globalStyledComponent";
import { useField, useFormikContext } from "formik";

export default function SelectComponent({ name, options, ...otherProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, metaData] = useField(name);

  const handleChange = (e) => {
    setFieldValue(name, e.target.value);
  };
  const selectConfig = {
    ...field,
    ...otherProps,
    select: true,
    variant: "outlined",
    fullWidth: true,
    onChange: handleChange,
  };

  if (metaData && metaData.touched && metaData.error) {
    selectConfig.error = true;
    selectConfig.helperText = metaData.error;
  }
  return (
    <CustomTextField {...selectConfig} size="small">
      {options &&
        options?.map((option, index) => {
          return (
            <MenuItem value={option} key={index}>
              {option}
            </MenuItem>
          );
        })}
    </CustomTextField>
  );
}
